import axios from 'axios';

const BASE_HEADERS = {
  // headers, without this, it will throw unsupported media type error
  // 'content-type': 'application/json; charset=utf-8',
  'content-type': 'multipart/form-data; charset=utf-8',
  // 'Access-Control-Allow-Origin': '*',
  // 'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
  // 'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
  Accept: 'application/json',
  // Authorization: `Bearer ${localStorage.getItem("jwt")}`
};

/**
 * @description
 * axios instance with default
 * baseUrl & headers etc. for global use
 */
const conObj = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: BASE_HEADERS,
});

/**
 * @description
 * axios instance to be used with converting payload to form data
 * baseUrl & headers etc. for global use
 */
export const conObjForm = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: BASE_HEADERS,
});

/**
 *
 * @param {string} reqType form/json(default) // Add more for future
 * @returns
 */
const interceptReq =
  (reqType = 'json') =>
  (request) => {
    // Need to check if jwt already expired?
    /**
     * Moved this piece of code here so that localStorage.getItem("jwt")
     * is always getting the latest value.
     * If follow old settings, still need to refresh the whole site to
     * reflect the latest localStorage values
     * */

    if (localStorage.getItem(`accessToken`)) {
      request.headers.Authorization = `Bearer ${localStorage.getItem('accessToken')}`;
    }

    const _accessToken = localStorage.getItem(`accessToken`);

    const payload = {
      ...request.data,
      device: 'web',
      appversion: process.env.REACT_APP_VERSION,
      passkey: process.env.REACT_APP_PASSKEY,
      ...(_accessToken && { token: _accessToken }),
    };

    if (reqType === 'form') {
      const params = new FormData();
      Object.keys(payload || {}).forEach((key) => {
        if (payload[key] !== undefined && payload[key] !== null) {
          params.append(key, payload[key]);
        }
      });

      request.data = params;
    } else {
      request.data = payload;
    }

    // saveLogs(request);
    return request;
  };

conObj.interceptors.request.use(interceptReq());
conObjForm.interceptors.request.use(interceptReq('form'));

conObj.interceptors.response.use(
  (response) =>
    // saveLogs(response);
    // eslint-disable-next-line arrow-body-style
    {
      // Do success intercept code here if necesary

      // if (typeof response.data?.data?.status !== 'undefined' && response.data?.data?.status !== 1) {
      // if (response.data?.data?.status === -999) {
      //   // kickout user
      //   localStorage.clear();
      //   window.location.reload();
      // }
      // because validationErrors is more detailed, show only if it has
      // if (response.data?.data?.validationErrors) throw new Error(response.data?.data?.validationErrors.toString());

      //   throw new Error(response?.data?.data?.msg);
      // }
      return response;
    },
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem('accessToken');
      const apiPath = error?.config?.url;

      console.log("error path", apiPath)

      if (apiPath !== 'login') {
        window.location.replace('/');
      }
    }

    return Promise.reject(error);
    // Do error intercept here
    // if (!axios.isCancel(error)) {
    // if (error?.response?.status === 401) {
    // const lastPath = window.location.hash;
    // sessionStorage.setItem('lastPath', lastPath.substring(1, lastPath.length));
    // localStorage.clear();
    // window.location.replace('/');
    // }
    // return Promise.reject(error);
    // }
    // console.log('Cancelled');
  }
);

export const updateHeaders = (newHeaders) => {
  const baseHeaders = {
    ...BASE_HEADERS,
    ...newHeaders,
  };

  // Create a new Axios instance with updated headers
  conObj.defaults.headers = baseHeaders;
};

// function saveLogs(req_data) {
//   const data = {
//     secret: 'secret',
//     req_data: req_data,
//     jwt: localStorage.getItem('jwt'),
//   };
//   axios
//     .post(process.env.REACT_APP_LOGGER_API, data, axiosConfig)
//     .then((res) => {
//       //do nothing
//     })
//     .catch((err) => {
//       console.log('Something went wrong while calling save logs: ' + err);
//     });
// }

// Only use for POST/PUT/DELETE API Actions
export const showResponseError = (error, enqueueSnackbar) => {
  if (!enqueueSnackbar) return console.error('enqueueSnackbar parameter is missing');
  const snackbarOptions = { variant: 'error', autoHideDuration: 5000 };
  const errorMessages = error?.response?.data?.errors;
  let errorMessage = error?.response?.data?.message || error?.response?.data?.internalMessage;

  if (typeof errorMessage === 'string') {
    try {
      errorMessage += `: ${[...error?.response?.data?.errorData].join(', ')}`;
    } catch (err) {
      /// ignore
    }
    enqueueSnackbar(errorMessage, snackbarOptions);
  } else if (errorMessages && Object.keys(errorMessages).length) {
    Object.keys(errorMessages).forEach((key) => enqueueSnackbar(errorMessages[key], snackbarOptions));
  } else enqueueSnackbar(`Server Error: ${error.message}`, snackbarOptions);

  return true;
};

export default conObj;
